<template>
  <div>
    <el-table :data="displayData" class="mb-3">
      <el-table-column prop="date" :label="$t('promotion.vps.claimTable.submissionDate')" min-width="150">
        <template slot-scope="scope">{{ scope.row.submissionDateDisplay }}</template>
      </el-table-column>
      <el-table-column prop="invoiceDate" :label="$t('promotion.vps.claimTable.invoiceStartDate')" min-width="150">
        <template slot-scope="scope"> {{ scope.row.invoiceStartDateDisplay }} </template>
      </el-table-column>
      <el-table-column prop="status" :label="$t('promotion.vps.claimTable.status')" min-width="150">
        <template slot-scope="scope">
          <div>
            <span :class="`dot-${scope.row.statusCode}`">
              <span>{{ getStatus(scope.row.statusCode) }}</span>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="notes" :label="$t('promotion.vps.claimTable.remarks')" min-width="150">
        <template slot-scope="scope"
          ><div
            v-html="getNotes(scope.row.notesCP, scope.row.statusCode, scope.row.accountNo, scope.row.refundedAmount)"
          ></div
        ></template>
      </el-table-column>
    </el-table>

    <Pagination :table-data="tableData" :display-data.sync="displayData" :customizedPageSize="pageSize"></Pagination>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';

export default {
  name: 'VpsClaimHistory',
  props: { tableData: Array },
  components: { Pagination },
  data() {
    return {
      displayData: [],
      pageSize: 10
    };
  },
  methods: {
    getStatus(StatusCode) {
      let status;
      switch (StatusCode) {
        case 0:
          status = this.$t('common.column.vps.submitted');
          break;
        case 1:
          status = this.$t('common.column.vps.refunded');
          break;
        case 2:
          status = this.$t('common.column.vps.approved');
          break;
        case 9:
          status = this.$t('common.column.vps.rejected');
          break;
      }
      return status;
    },
    getNotes(NotesObj, StatusCode, accNo, refundedAmount) {
      let notes = '';

      switch (StatusCode) {
        case 1:
          notes = `${accNo}-${refundedAmount}`;
          break;
        case 9:
          const { rejectReason: reasonArr } = JSON.parse(NotesObj);
          reasonArr.forEach(reason => {
            notes += this.$t(`${reason}`) + '<br />';
          });
          break;
        default:
          notes = this.$t(`${NotesObj}`);
      }
      return notes;
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin dot-color($color) {
  span::before {
    content: ' \25CF';
    font-size: 16px;
    color: $color;
    @include rtl-sass-prop('margin-right', 'margin-left', 8px);
  }
}

// submitted
.dot-0 {
  @include dot-color(#0051ff);
}

// refunded
.dot-1 {
  @include dot-color($stone-gray);
}

// approved
.dot-2 {
  @include dot-color(#79db35);
}

// rejected
.dot-9 {
  @include dot-color(#ff0000);
}
</style>
